<div class="padding-large m-padding">
  <div class="page-layout">
    @if (!loading && !enabled) {
      <div class="bg-light-grey padding-largest margin-top flex column center">
        <i class="fa-solid fa-link-slash fa-2xl margin-bottom grey"></i>
        <span>This share link is no longer active</span>
      </div>
    } @else {
    <div class="flex center between m-column m-start">
      <h4>Shared media</h4>

      <span class="primary hover flex center" (click)="downloadImagesByMediaShareLinkId()">
        <i class="fa fa-download margin-right-smallest"></i>
        Download ZIP
      </span>
    </div>

    @for (product of mediaShareDetails; track product.style.modelId) {
      <div class="flex column margin-top-small border radius">
        <div class="flex center between bg-light-grey padding-small radius radius-bottom-none">
          <div class="flex center">
            <div class="flex column">
              <b class="primary-dark">{{ product.style.code }} - {{ product.style.name }}</b>
            </div>

            @if (!product.opened) {
              <span class="margin-left">
                @for (color of product.colors.slice(0, 5); track color.color.id; let last = $last) {
                  {{ color.color.code }} {{ color.color.name }}
                  @if (!last) {
                    ,
                  }
                }

                @if (product.colors.length > 5) {
                  <span class="grey margin-left-smallest">+ {{ product.colors.length - 5 }} others</span>
                }
              </span>
            }
          </div>

          <div class="flex center">
            <i
              class="fa-solid {{ product.opened ? 'fa-chevron-up' : 'fa-chevron-down' }} hover"
              (click)="toggle(product)"
            ></i>
          </div>
        </div>

        @if (product.opened) {
          @for (color of product.colors; track color.color.id) {
            <div class="padding">
              <div class="between flex center m-column m-start">
                <div class="flex center">
                  <span class="bg-light-grey border primary bold padding-left-smallest padding-right-smallest radius">
                    {{ color.color.code }} {{ color.color.name || '-' }}
                  </span>
                </div>

                <div class="flex center m-full-width m-margin-top-small">
                  @if (color.isAi) {
                    <div
                      class="flex center bg-orange primary padding-left-smallest padding-right-smallest border radius margin-right"
                    >
                      <i class="fa-solid fa-robot margin-right-smallest"></i>
                      AI generated
                    </div>
                  }

                  <div
                    class="flex center primary hover desktop-only {{
                      getShotsWithImages(color).length ? '' : 'disabled'
                    }}"
                    (click)="viewGallery(getShotsWithImages(color))"
                  >
                    <i class="fa-solid fa-expand margin-right-small"></i>
                    View as gallery
                  </div>
                </div>
              </div>

              <div class="shot-grid margin-top">
                @for (shot of color.shots; track shot.id) {
                  <div
                    class="padding-small flex column border border-grey radius between {{
                      shot.shotApprovalStatus == ShotApprovalStatus.Approved
                        ? 'bg-light-green border-green'
                        : shot.shotApprovalStatus == ShotApprovalStatus.Rejected
                          ? 'bg-light-red border-red'
                          : 'bg-white'
                    }}"
                  >
                    <div class="flex center">
                      <div class="flex-0 margin-right-small">
                        @if (shot.imgPath) {
                          <div class="placeholder shot-image-wrapper">
                            <img
                              class="shot-image hover"
                              (click)="viewGallery(getShotsWithImages(color), shot.id)"
                              [src]="shot.imgPath"
                              alt="Shot preview"
                            />
                            @if (isVideo(shot)) {
                              <i class="fa-solid fa-circle-play video-play-icon"></i>
                            }
                          </div>
                        } @else {
                          <div class="placeholder flex center justify-center">
                            <i class="grey fa fa-image"></i>
                          </div>
                        }
                      </div>

                      <div class="flex-1 flex column">
                        <div class="flex center between">
                          <b>{{ shot.shotType?.name }}</b>
                        </div>

                        <div class="flex column small">
                          <div>
                            {{ shot.aspectRatio?.id == 1 ? 'Square' : '-' }}
                            {{ shot.aspectRatio?.label }},
                            {{ shot.mediaFormat?.name }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="flex center between">
                      @if (shot.isAi) {
                        <div
                          matTooltip="AI generated"
                          class="flex center bg-orange primary padding-smallest border radius margin-top-smallest"
                        >
                          <i class="fa-solid fa-robot"></i>
                        </div>
                      } @else {
                        <div></div>
                      }

                      <div class="flex center">
                        @if (shot.shotApprovalStatus == ShotApprovalStatus.Rejected) {
                          <div class="padding-smallest bg-red white flex center radius margin-top-small">Rejected</div>
                        } @else if (shot.shotApprovalStatus == ShotApprovalStatus.Approved) {
                          <div class="padding-smallest bg-green white flex center radius margin-top-small">
                            Approved
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                } @empty {
                  <div class="bg-light-grey padding-small flex column justify-center center fix-height grey">
                    No shots for this color
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    } @empty {
      @if (!loading) {
        <div class="bg-light-grey padding-largest margin-top flex column center">
          <i class="fa-solid fa-search fa-2xl margin-bottom grey"></i>
          <span>No shared media found</span>
        </div>
      }
    }
    }
  </div>
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
